import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=61287641&scoped=true"
import script from "./contact.vue?vue&type=script&lang=js"
export * from "./contact.vue?vue&type=script&lang=js"
import style0 from "./contact.vue?vue&type=style&index=0&id=61287641&prod&scoped=true&lang=less"
import style1 from "@/assets/h5css/mobile/contact.less?vue&type=style&index=1&id=61287641&prod&scoped=true&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61287641",
  null
  
)

export default component.exports